(() => {
  if (customElements.get('radio-lab')) return;
  class RadioLab extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const vswr = this.querySelector('[data-vswr-input]');
      if (vswr) {
        const update = () => {
          const value = Number(vswr.value), percent = ((value - 1) / (value + 1)) ** 2 * 100;
          this.querySelector('[data-vswr]').textContent = `${value.toLocaleString(document.documentElement.lang)}:1`;
          this.querySelector('[data-reflection]').style.setProperty('--bar', `${percent}%`);
          this.querySelector('[data-output]').textContent = `${percent.toLocaleString(document.documentElement.lang, {maximumFractionDigits: 1})}%`;
        };
        vswr.addEventListener('input', update); update();
      }
      const rf = this.querySelector('[data-rf]'), lo = this.querySelector('[data-lo]');
      if (rf && lo) {
        const update = () => {
          const valid = rf.value !== '' && lo.value !== '' && rf.validity.valid && lo.validity.valid;
          this.querySelector('[data-difference]').textContent = valid ? Math.abs(Number(rf.value) - Number(lo.value)).toLocaleString(document.documentElement.lang) : '—';
          this.querySelector('[data-sum]').textContent = valid ? (Number(rf.value) + Number(lo.value)).toLocaleString(document.documentElement.lang) : '—';
        };
        rf.addEventListener('input', update); lo.addEventListener('input', update); update();
      }
      const slider = this.querySelector('[data-sf-input]');
      if (slider) {
        const update = () => {
          const sf = Number(slider.value), ms = 2 ** sf / 125;
          this.querySelector('[data-sf]').textContent = sf;
          this.querySelector('[data-current]').textContent = `SF${sf} · 125 kHz`;
          this.querySelector('[data-bar]').style.setProperty('--bar', `${2 ** (sf - 12) * 100}%`);
          this.querySelector('[data-output]').textContent = `${ms.toLocaleString(document.documentElement.lang, {maximumFractionDigits: 3})} ms — ${this.dataset.symbol}`;
        };
        slider.addEventListener('input', update); update();
      }
      this.querySelectorAll('[data-pattern-button]').forEach(button => button.addEventListener('click', () => {
        this.querySelector('[data-pattern]').dataset.pattern = button.dataset.patternButton;
        this.querySelectorAll('[data-pattern-button]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      }));
      this.querySelector('[data-send]')?.addEventListener('click', () => {
        this.classList.remove('ek-playing');
        void this.offsetWidth;
        this.classList.add('ek-playing');
        this.querySelector('[data-output]').textContent = this.dataset.result;
      });
    }
  }
  customElements.define('radio-lab', RadioLab);
})();
